<template>
  <div class="col-12 g">
    <div class="card card-body">
      <h4>إعدادات المساعد الذكي</h4>
      <hr>
      <div class="row">
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label>اسم المساعد</label>
            <input type="text" class="form-control" v-model="settings.bot_name" placeholder="سعود">
          </div>
        </div>
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label>اسم المطور</label>
            <input type="text" class="form-control" v-model="settings.developer_name" placeholder="التحضير الذكي">
          </div>
        </div>
        <div class="col-12 col-lg-4 g">
          <div class="form-group">
            <label>اسم النظام</label>
            <input type="text" class="form-control" v-model="settings.system_name" placeholder="تحضير">
          </div>
        </div>
        <div class="col-12 g">
          <div class="form-group">
            <label>تعليمات إضافية للمساعد</label>
            <textarea class="form-control" v-model="settings.extra_instructions" rows="6" placeholder="أضف هنا أي تعليمات إضافية تريد أن يتبعها المساعد..."></textarea>
            <small class="text-muted">مثال: لا ترد على أسئلة خارج نطاق النظام، استخدم لهجة رسمية، الخ</small>
          </div>
        </div>
        <div class="col-12 g">
          <div class="form-group">
            <label>قاعدة المعلومات</label>
            <textarea class="form-control" v-model="settings.knowledge_base" rows="12" placeholder="اترك فارغاً لاستخدام قاعدة المعلومات الافتراضية (ai_replies.txt)"></textarea>
            <small class="text-muted">المعلومات التي يستخدمها المساعد للإجابة على الأسئلة (أسعار، خدمات، شروحات). اتركه فارغاً لاستخدام الملف الافتراضي.</small>
          </div>
        </div>
        <div class="col-12 text-center g">
          <button class="btn btn-primary btn-lg" @click="save()" v-if="!saving">
            <i class="fa fa-save"></i>
            حفظ الإعدادات
          </button>
          <button class="btn btn-secondary btn-lg disabled" disabled v-if="saving">
            جاري الحفظ...
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saving: false,
      settings: {
        bot_name: '',
        developer_name: '',
        system_name: '',
        extra_instructions: '',
        knowledge_base: ''
      }
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      var g = this;
      $.post(api + '/admin/ai-chats/settings', {
        jwt: localStorage.getItem('jwt')
      }).then(function(r) {
        if (r.status == 100) {
          g.settings = r.response;
        }
      })
    },
    save() {
      var g = this;
      g.saving = true;
      $.post(api + '/admin/ai-chats/settings/update', {
        jwt: localStorage.getItem('jwt'),
        bot_name: g.settings.bot_name,
        developer_name: g.settings.developer_name,
        system_name: g.settings.system_name,
        extra_instructions: g.settings.extra_instructions,
        knowledge_base: g.settings.knowledge_base
      }).then(function(r) {
        g.saving = false;
        if (r.status == 100) {
          alert('تم حفظ الإعدادات بنجاح')
        } else {
          alert(r.response)
        }
      }).fail(function() {
        g.saving = false;
      })
    }
  }
}
</script>
